<template>
  <div class="v-stack h-stretch gap-3">
    <div class="h-stack h-end">
      <button
        v-if="$store.state.accessLevel > 9"
        @click="$router.push('/users/crew/add')"
        class="add"
      >
        New
      </button>
    </div>
    <Table
      :loading="loading"
      :items="users"
      :defaultColumn="0"
      css="200px 80px 100px 1fr 60px"
      v-on:rowSelected="$router.push('/users/detail/' + $event._id)"
      :columns="[
        {
          name: 'Name',
          sort: 'alphabet',
          path: ['fullName'],
        },
        {
          name: 'Birthday',
          sort: 'date',
          formatType: 'date',
          format: 'DD.MM.YYYY',
          path: ['birthday'],
        },
        {
          name: 'Phone',
          sort: 'numeric',
          path: ['phoneNumber'],
          formatType: 'phone',
        },
        {
          name: 'Email',
          sort: 'alphabet',
          path: ['email'],
        },
        {
          name: 'Hours',
          sort: 'numeric',
          path: ['totalHours'],
        },
      ]"
    ></Table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Table from "@/components/Table.vue";

export default {
  data() {
    return {
      users: [],
      loading: true,
    };
  },
  components: {
    Table,
  },
  methods: {
    ...mapActions(["getCrewInfo"]),
    refresh() {
      this.loading = true;
      this.getCrewInfo()
        .then((users) => {
          this.users = users;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>
